// This is a service that handles data fetching and processing

import sampleData from "./sample-data";
import { processPatientData } from "./data-processor";
import { fetchPatientDataFromAPI, submitToAICVDModel } from "./api-service";

// Flag to toggle between mock data and real API calls
const USE_MOCK_DATA = false; // Set to false to use real API calls

// Fetch patient data from MongoDB or use mock data
export async function fetchPatientData(uhid) {
  if (USE_MOCK_DATA) {
    // Use mock data for development/testing
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(sampleData);
      }, 1000); // Simulate network delay
    });
  } else {
    try {
      return await fetchPatientDataFromAPI(uhid);
    } catch (error) {
      console.error("Error fetching patient data:", error);
      throw error;
    }
  }
}

// Map patient data
export async function mapPatientData(patientData) {
  return new Promise((resolve) => {
    setTimeout(() => {
      const { mappedData, mappingPaths } = processPatientData(patientData);
      resolve({ mappedData, mappingPaths });
    }, 1500); // Simulate processing delay
  });
}

export async function getMappedPatientData(uhid) {
  return new Promise(async (resolve) => {
    const patientData = await fetchPatientData(uhid);
    const { mappedData, mappingPaths } = await mapPatientData(patientData);
    resolve({ mappedData, mappingPaths });
  });
}
export async function getAICVDResults(uhid, patientData = null) {
  try {
    if (!patientData) {
      const { mappedData } = await getMappedPatientData(uhid);
      
      patientData = mappedData;
    }

    return await submitToAICVDModel(patientData);
  } catch (error) {
    console.error("Error getting AICVD results:", error);
    throw error;
  }
}
